import { NikePrivacy } from './privacy';
import { store } from './store';
window.NikePrivacy = new NikePrivacy(store);
